import React from "react";
import styled from "styled-components";
import { pxToRem } from "@input-output-hk/px-to-rem";

const StyledCloseImageButton = styled.button`
  height: ${pxToRem(35)};
  width: ${pxToRem(35)};
  padding: 0;
  margin: 0;
  background: transparent;
  border: 0;
`;

const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`;
export const CloseImageButton = ({
  onClick,
  className
}: React.HTMLProps<HTMLButtonElement>) => (
  <StyledCloseImageButton
    onClick={onClick}
    className={className}
    title="closeImageButton"
  >
    <Svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill="#2353FF" />
      <path
        d="M8.99631 27.9305L13.5434 23.3835L13.5434 26.9438L14.9467 26.9388L14.9467 20.9884L8.99631 20.9884L8.99631 22.3868L12.5517 22.3917L8.00458 26.9388L8.99631 27.9305Z"
        fill="white"
      />
      <path
        d="M28.632 26.5984L24.0849 22.0513L27.6452 22.0513L27.6402 20.648L21.6899 20.648L21.6898 26.5984L23.0882 26.5984L23.0931 23.0431L27.6402 27.5901L28.632 26.5984Z"
        fill="white"
      />
      <path
        d="M27.2996 7.66455L22.7525 12.2116L22.7525 8.65132L21.3492 8.65628L21.3492 14.6067L27.2996 14.6067L27.2996 13.2083L23.7442 13.2034L28.2913 8.65628L27.2996 7.66455Z"
        fill="white"
      />
      <path
        d="M7.66589 8.99655L12.213 13.5436L8.65267 13.5436L8.65762 14.9469L14.608 14.9469L14.608 8.99655L13.2097 8.99655L13.2047 12.5519L8.65762 8.00483L7.66589 8.99655Z"
        fill="white"
      />
    </Svg>
  </StyledCloseImageButton>
);
